import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from '../client';
import type {
    ListServicesParams,
    ServiceDocumentChecklistPutPayload,
    ServiceDocumentChecklistResponse,
    ServicePatchPayload,
    ServiceRecord,
    ServiceWritePayload,
} from 'types/servicesDocuments';

/** Legacy list for a single service provider (dashboard flows). */
export function get(service_provider_id: number, customConfig?: AxiosRequestConfig) {
    const url = `/services?service_provider_id=${service_provider_id}`;
    return client.get(url, customConfig);
}

export const listServices = (
    params?: ListServicesParams,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceRecord[]>> => {
    return client.get<ServiceRecord[]>('/services', {
        ...customConfig,
        params: {
            ...(customConfig?.params || {}),
            ...(params || {}),
        },
    });
};

export const createService = (
    payload: ServiceWritePayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceRecord>> => {
    return client.post<ServiceRecord>('/services', payload, customConfig);
};

export const updateService = (
    serviceId: number,
    payload: ServicePatchPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceRecord>> => {
    return client.patch<ServiceRecord>(`/services/${serviceId}`, payload, customConfig);
};

export const deleteService = (
    serviceId: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceRecord>> => {
    return client.delete<ServiceRecord>(`/services/${serviceId}`, customConfig);
};

export const getServiceDocumentChecklist = (
    serviceId: number,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceDocumentChecklistResponse>> => {
    return client.get<ServiceDocumentChecklistResponse>(
        `/services/${serviceId}/document-checklist`,
        customConfig
    );
};

export const putServiceDocumentChecklist = (
    serviceId: number,
    payload: ServiceDocumentChecklistPutPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ServiceDocumentChecklistResponse>> => {
    return client.put<ServiceDocumentChecklistResponse>(
        `/services/${serviceId}/document-checklist`,
        payload,
        customConfig
    );
};
